<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-08-16 17:09:59
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 11:35:28
 * @FilePath: /chaoyongtuan/src/components/business/applySampleDrawer/components/chooseCooPartner/tableCell/drInfoCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-11 15:13:40
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-31 16:36:22
-->
<template>
	<!-- 达人信息组件 -->
	<div class="drInfoCell">
		<div class="left">
			<yx-avatar :src="row.head"></yx-avatar>
		</div>
		<div class="right ml-10">
			<p class="yx-color-text-primary font-h4-regular">{{ row.anchor_name }}</p>
			<p class="yx-color-text-regular font-h6-regular">
				<span>{{ row.platform_id | formatPlatformName('suf') }}：</span>
				<span class="ml-10">{{ anchorAccount }}</span>
			</p>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	name: 'drInfoCell',
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		anchorAccount() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.row.anchor_uid,
			};
			return temPF[this.row.platform_id];
		},
	},
	components: {},
};
</script>
<style lang="less" scoped>
.drInfoCell {
	display: flex;
	align-items: center;
}
</style>
